import './EventVideoAttachment.scss';

import React from 'react';

import Screen from '../Screen';
import Scrollable from '../../elements/Scrollable';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import VerticalCenter from '../../elements/VerticalCenter';

export default class EventVideoAttachment extends React.Component {
    render() {
        let header = (
            <div>
                <TopBarEvent event={this.props.event} onReturnClick={this.props.onReturnClick} returnURL={this.props.returnURL || '..'} icons={this.props.icons} />
                <hr />
            </div>
        );

        return (
            <Screen className="EventVideoAttachment" header={header}>
                <video src={this.props.src} autoPlay loop controls />
            </Screen>
        );
    }
}
